import React, { useState } from "react";
import { Label } from "@progress/kendo-react-labels";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { Field } from "@progress/kendo-react-form";

export default function Branch({
  branchList = [],
  loading = false,
  component,
  disabled = false,
  width = "255px",
  height = "44px",
  valueSetter,
  controlled = false,
  name,
  className,
  onChange,
  value,
  style,
  labelClass,
  bgColor,
}) {
  const [filter, setFilter] = useState("");

  const filteredData = filter
    ? branchList.filter((item) =>
        item.display?.toLowerCase().includes(filter.toLowerCase())
      )
    : branchList;

  return (
    <div className={`${className} d-flex flex-column`} style={style}>
      <Label className={`label  ${labelClass}`}>Branch</Label>
      {controlled ? (
        <ComboBox
          style={{
            width: width,
            height: height,
            backgroundColor: bgColor,
          }}
          className="ps-2"
          data={filteredData}
          textField="display"
          placeholder="Select Branch"
          dataItemKey="branchId"
          iconClassName="wa"
          value={value}
          onChange={(e) => {
            setFilter("");
            onChange(e.value);
          }}
          filterable={true}
          onFilterChange={(e) => setFilter(e.filter.value)}
          component={ComboBox}
          loading={loading}
        />
      ) : (
        <Field
          disabled={disabled}
          style={{ width: width, height: "44px" }}
          data={branchList}
          name={name}
          textField="display"
          placeholder="Select Branch"
          dataItemKey="branchId"
          iconClassName="wa"
          component={ComboBox}
        />
      )}
    </div>
  );
}
